module.exports = new __parcel__URL__("contribution1Output.7ac6adbb.jpg").toString();